<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isSeller()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Current Auctions</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
<section class="content">
<!-- main row for all icons  -->
<div class="col-sm-9">
<div v-if="auctions.length == 0">
			<h3>No Data</h3>
			<img src="../images/nodata.svg" alt="No data image">
		</div>
	<div class="card card-primary" style="border-radius: 30px !important;" v-else-if="auctions!=''" v-for="auction in auctions" :key="auction.id">
		<div class="card-body row">
			<div class="col-sm-9 float-left">
				<h3>{{auction.auction_id}}</h3>
				<p>
					<h5 class="gtext">Started At:</h5> {{auction.schedule_start}}<br>
          <br>
          <h5 class="gtext">Ending At:</h5> {{auction.schedule_end}}
				</p>
			</div>
			<div class="col-sm-3 mx-auto d-block" align="center">
				<button class="btn btn-success" @click="lots(auction.id)" style="margin-top: 10%;border-radius: 20px;"><b>View Lots in the Auction</b></button>
			</div>
    </div>
	</div>
  
</div>
</section>
    <!-- /.content -->
<br>
      <br>

<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isSeller()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        
        created(){
        	this.getAuctions();
        },
        
    		data(){
        	return{
        		auctions: []
         }
       },
       
       methods: {
       	getAuctions(url="/api/getCurrentAuctions"){
       		axios.post(url)
       		.then(response => {
       			this.auctions = response.data;
       		})
       	},
       	
       	lots(id){
       		this.$router.push("/home/seller/auction-lots/"+id);
       	}
      }
    }
</script>
